import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      marginLeft: theme.spacing(1),
      border: '1px solid #CDCEDA',
      borderRadius: '4px',
      padding: 0,
    },
    iconButton: {
      padding: 10,
    },
    btnPrimary: {
      backgroundColor: '#000A8C',
      color: '#FFFFFF',
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '100%',
      textTransform: 'none',
      padding: '12px 24px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '&:hover': {
        backgroundColor: '#1a1f5a',
      },
    },
    search: {
      width: '80%',
      margin: '0  auto',
      display: 'flex',
      alignItems: 'center',
    },
    btn: {
      color: 'white',
      letterSpacing: 0,
      opacity: 1,
      background: '#0E1247',
      borderRadius: 3,
      textTransform: 'none',
      height: 46,
    },
    searchButton: {
      marginLeft: 20,
    },
  }),
);

export default useStyles;
